import { createSlice } from "@reduxjs/toolkit";

export const conversationSlice = createSlice({
  name: "conversations",
  initialState: {
    conversations: [],
    convoWindow: false,
    currentConvoId: false,
    unreadMessages: 0,
    currentAgentTextingNumber: false,
    currentLeadTextingNumber: false,
  },
  reducers: {
    setConversations(state, action) {
      state.conversations = action.payload;
    },
    addConversation(state, action) {
      state.conversations.push(action.payload);
    },
    updateConversation(state, action) {
      const { convo_id, updatedConversation } = action.payload;
      const index = state.conversations.findIndex(
        (conversation) => conversation.convo_id === convo_id
      );
      if (index !== -1) {
        state.conversations[index] = updatedConversation;
      }
    },
    setConvoId(state, action) {
      state.currentConvoId = action.payload;
    },
    setConvoWindow(state, action) {
      state.convoWindow = action.payload;
    },
    updateUnreadMessages(state, action){
        state.unreadMessages = action.payload
    },
    incrementUnreadMessages(state){
        state.unreadMessages += 1
    },
    decrementUnreadMessages(state){
        state.unreadMessages -= 1
    },
    updateTextingNumbers(state, action) {
        const {agentNumber, leadNumber} = action.payload

        state.currentAgentTextingNumber = agentNumber
        state.currentLeadTextingNumber = leadNumber
    }
  },
});
export const {
  setConversations,
  addConversation,
  updateConversation,
  setConvoWindow,
  setConvoId,
  updateUnreadMessages,
  incrementUnreadMessages,
  decrementUnreadMessages,
  updateTextingNumbers,
} = conversationSlice.actions;

export default conversationSlice.reducer;
